"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function assertUnreachable(x) {
    throw new Error("Didn't expect to get here");
}
exports.assertUnreachable = assertUnreachable;
//# sourceMappingURL=assertUnreachable.js.map